/* eslint-disable */
import { useState } from "react";

export default function Img({ src, alt, style, objectPosition }) {
  const [err, setErr] = useState(false);
  const [ok, setOk] = useState(false);

  if (err) return <div style={{ ...style, background: "#E8DDD0" }} />;

  return (
    <div style={{ ...style, position: "relative", overflow: "hidden" }}>
      {!ok && (
        <>
          <div style={{ position: "absolute", inset: 0, background: "#F0EAE0" }} />
          <div style={{
            position: "absolute", inset: 0,
            background: "linear-gradient(90deg, transparent 0%, rgba(176,112,128,0.06) 50%, transparent 100%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.5s ease-in-out infinite",
          }} />
        </>
      )}
      <img
        src={src}
        alt={alt || ""}
        onError={() => setErr(true)}
        onLoad={() => setOk(true)}
        style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: objectPosition || "center", display: "block", opacity: ok ? 1 : 0, transition: "opacity 0.5s" }}
      />
    </div>
  );
}
